import { createReducer, on } from '@ngrx/store';
import * as BankActions from './bank.actions';
import { initialBankState } from './bank.state';

export const bankReducer = createReducer(
  initialBankState,

  // 🚚 Load All (Paginated)
  on(BankActions.loadBanks, (state, { page, pageSize, sortBy, sortOrder }) => ({
    ...state,
    loading: true,
    page,
    pageSize,
    sortBy,
    sortOrder,
    error: null,
  })),

  on(
    BankActions.loadBanksSuccess,
    (state, { banks, total, page, pageSize, sortBy, sortOrder }) => ({
    ...state,
    banks,
    total,
    page,
    pageSize,
      sortBy,
      sortOrder,
    loading: false,
    }),
  ),

  on(BankActions.loadBanksFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Create
  on(BankActions.createBank, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(BankActions.createBankSuccess, (state, { bank }) => ({
    ...state,
    banks: [bank, ...state.banks],
    loading: false,
    error: null,
  })),

  on(BankActions.createBankFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Update
  on(BankActions.updateBank, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(BankActions.updateBankSuccess, (state, { bank }) => ({
    ...state,
    banks: state.banks.map((b) => (b.id === bank.id ? bank : b)),
    loading: false,
    error: null,
  })),

  on(BankActions.updateBankFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Delete
  on(BankActions.deleteBank, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(BankActions.deleteBankSuccess, (state, { id }) => ({
    ...state,
    banks: state.banks.filter((b) => b.id !== id),
    loading: false,
    error: null,
  })),

  on(BankActions.deleteBankFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
